import React from 'react';
import IconSonstiges from './assets/b2b-icon-sonstiges.png';
import BaseIcon from './BaseIcon';

const SonstigesIcon: React.FC<any> = ({ alt, width, height }: any) => (
  <BaseIcon width={width} height={height} alt={alt} src={IconSonstiges} />
);

export default SonstigesIcon;
